import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from '../users/auth.guard';
import { LicenseListComponent } from './license-list/license-list.component';
import { LicenseEditComponent } from './license-edit/license-edit.component';
import { LicenseDetailComponent } from './license-detail/license-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LicenseListResolver } from './license-list/license-list-resolver.service';
import { EditGuard } from '../shared/edit.guard';
import { ListGuard } from '../shared/list.guard';
import { FooterComponent } from '../shared/footer/footer.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ChipsModule } from 'primeng/chips';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { HighlightPipe } from '../shared/highlight.pipe';
import { provideServerRendering } from '@angular/platform-server';

@NgModule({
  imports: [
//    TagInputModule,   // Needs to be first
    NgxMaskModule.forRoot(),
    CommonModule,
    FormsModule,
    FooterComponent,
    HighlightPipe,
    AutoCompleteModule, 
    ChipsModule,
    NgbModule,   
    RouterModule.forChild([
      {
        path: 'license/:id/edit',
        canActivate: [AuthGuard] ,
        canDeactivate: [EditGuard],
        component: LicenseEditComponent
      },
      {
        path: 'license/:id',
        component: LicenseDetailComponent
      },
      {
        path: 'license/auth/:authid', component: LicenseListComponent,
        canDeactivate: [ListGuard],
        resolve: { resolvedData: LicenseListResolver }    
      },
      {
        path: 'license/coord/:coordid', component: LicenseListComponent,
        canDeactivate: [ListGuard],
        resolve: { resolvedData: LicenseListResolver }    
      },
      {
        path: 'license', component: LicenseListComponent,
        canDeactivate: [ListGuard],
        resolve: { resolvedData: LicenseListResolver }          
      }
     ])
  ],

  declarations: [
    LicenseListComponent,
    LicenseEditComponent,
    LicenseDetailComponent
  ]
})
export class LicenseModule { }